import useOnMount from '../../hooks/useOnMount'
import { analytics } from 'services/Analytics/Analytics'

export default function useScrollToBottom({
  screenName,
  analyticsProps,
  bottomOffset = 100,
}: {
  screenName: string
  analyticsProps: Record<string, unknown>
  bottomOffset?: number
}) {
  useOnMount(() => {
    const trackScrolling = () => {
      const isReachedBottom =
        window.scrollY + window.innerHeight >
        document.body.scrollHeight - bottomOffset
      if (isReachedBottom) {
        analytics.trackOncePerSession(
          `${screenName} - Scrolled to Bottom`,
          analyticsProps
        )
      }
    }

    document.addEventListener('scroll', trackScrolling)
    return () => {
      document.removeEventListener('scroll', trackScrolling)
    }
  })
}
